import { alertAuthExpired, fetchFfdJson } from "shared/api/ffdClient";
import { downloadViaIframe } from "shared/utils/downloadFile";

export const fetchZipFromS3 = async (
  authToken: string,
  cfd_id: string,
  taskArn: string | null,
  fileName?: string
) => {
  // Get URL
  let object_url: string = '';

  try {
    const params = [`trial_id=${cfd_id}`];
    if (taskArn) params.push(`task_arn=${encodeURIComponent(taskArn)}`);
    if (fileName) params.push(`file_name=${encodeURIComponent(fileName)}`);
    const requestPath = `/trials/download?${params.join('&')}`;

    const { response, data } = await fetchFfdJson<{ body?: any; text?: string }>(
      requestPath,
      authToken
    );
    if (response.status === 200) {
      object_url = data.body?.url?.toString() ?? "";
    } else if (response.status === 201) {
      if (data.text) alert(`${data.text}`);
      return data.body?.task_arn?.toString() ?? null;
    } else {
      if (data.text) alert(`${data.text}`);
      return null;
    }
  } catch (error) {
    alertAuthExpired();
    return;
  }

  // Download
  setTimeout(() => {
    try {
      if (object_url !== '') {
        downloadViaIframe(object_url);
      }
      return null;
    } catch (error) {
      console.error(`Error downloading the file: ${error}`);
    }
  }, 1000);
};
